import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppId } from '../../context/AppIdContext';
import Header from '../../component/header';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const ProfilePage = () => {
    const navigate = useNavigate();
    
    // --- State for photo upload ---
    const [isUploadingPhoto, setIsUploadingPhoto] = useState(false);
    const [photoUrl, setPhotoUrl] = useState(null);
    const fileInputRef = useRef(null);
    
    // --- Context & LocalStorage Data ---
    // 🔴 FIX: Added appId to context extraction
    const { language, userName, userType, userId, setUserPhoto, appId } = useAppId();
    const lang = language || localStorage.getItem('language') || 'en';

    // Fetch user details safely from context or localStorage
    const name = userName || localStorage.getItem('userName') || localStorage.getItem('name') || "Admin User";
    const rawRole = userType || localStorage.getItem('userType') || localStorage.getItem('role') || "Admin";
    const mobile = localStorage.getItem('mobileNo') || localStorage.getItem('mobile_no') || "+91 XXXXX XXXXX";
    
    // Get user ID for API calls
    const currentUserId = userId || localStorage.getItem('userId');

    // Get photo from state or localStorage
    const defaultPhoto = `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=f1f5f9&color=0f172a&size=150`;
    const storedPhoto = localStorage.getItem('userPhoto') || localStorage.getItem('photo_path');
    const profilePhoto = photoUrl || storedPhoto || defaultPhoto;

    // Format role nicely
    const displayRole = rawRole === 'A' ? 'Admin' : 
                        rawRole === 'SA' ? 'Sub Admin' : 
                        rawRole === 'BP' ? 'Booth Pramukh' : 
                        rawRole === 'SP' ? 'Shakti Kendra Pramukh' :
                        rawRole === 'K'  ? 'Volunteer' : rawRole;      
                    
    // --- Translations ---
    const t = { 
        en: {
            title: "My Profile",
            allUser: "All User",
            liveVoting: "Live Voting User",
            postTimeline: "Post Timeline",
            changeResp: "Change Responsibility",
            privacyPolicy: "Privacy Policy",
            contactUs: "Contact Us",
            logout: "Log out",
            logoutConfirm: "Are you sure you want to log out?",
            changeWard: "Change Ward",
            updatePhoto: "Update Photo",
            photoUpdated: "Profile photo updated successfully!",
            photoError: "Error updating profile photo.",
            uploading: "Uploading..."
        },
        hi: {
            title: "मेरी प्रोफ़ाइल",
            allUser: "सभी उपयोगकर्ता",
            liveVoting: "लाइव वोटिंग उपयोगकर्ता",
            postTimeline: "पोस्ट टाइमलाइन",
            changeResp: "जिम्मेदारी बदलें",
            privacyPolicy: "गोपनीयता नीति",
            contactUs: "संपर्क करें",
            logout: "लॉग आउट",
            logoutConfirm: "क्या आप वाकई लॉग आउट करना चाहते हैं?",
            changeWard: "वार्ड बदलें",
            updatePhoto: "फोटो अपडेट करें",
            photoUpdated: "प्रोफ़ाइल फोटो सफलतापूर्वक अपडेट हुई!",
            photoError: "प्रोफ़ाइल फोटो अपडेट करने में त्रुटि।",
            uploading: "अपलोड हो रहा है..."
        },
        gu: {
            title: "મારી પ્રોફાઇલ",
            allUser: "બધા વપરાશકર્તા",
            liveVoting: "લાઇવ વોટિંગ વપરાશકર્તા",
            postTimeline: "પોસ્ટ ટાઇમલાઇન",
            changeResp: "જવાબદારી બદલો",
            privacyPolicy: "ગોપનીયતા નીતિ",
            contactUs: "અમારો સંપર્ક કરો",
            logout: "લૉગ આઉટ",
            logoutConfirm: "શું તમે ખરેખર લોગ આઉટ કરવા માંગો છો?",
            changeWard: "વોર્ડ બદલો",
            updatePhoto: "ફોટો અપડેટ કરો",
            photoUpdated: "પ્રોફાઇલ ફોટો સફળતાપૂર્વક અપડેટ થયો!",
            photoError: "પ્રોફાઇલ ફોટો અપડેટ કરવામાં ભૂલ.",
            uploading: "અપલોડ થઈ રહ્યું છે..."
        }
    };

    const txt = t[lang] || t.en;

    // --- 🔴 નવું લોજિક: સીધું જ CDN પર ફોટો અપલોડ કરીને ડેટાબેઝમાં એન્ટ્રી કરવી ---
    const handlePhotoChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setIsUploadingPhoto(true);

        try {
            // ૧. FormData બનાવીને CDN પર ફાઈલ અપલોડ કરવી
            const formData = new FormData();
            formData.append('api_key', 'BJP-Media-7Kx9Qm2pR4vN8wL3jH6tY5cF1bZ0aD');
            formData.append('app_id', appId?.toString() || "1");
            formData.append('user_id', currentUserId?.toString() || "1");
            formData.append('folder', 'files');
            formData.append('file', file);

            console.log("Uploading profile photo to CDN...");

            const cdnResponse = await axios.post(
                'https://cdn.bjpwings.com/ResourceUploadHandler.ashx',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            console.log("CDN Response:", cdnResponse.data);

            // ૨. જો CDN પર અપલોડ સફળ થાય, તો change_profile_photo API માં એન્ટ્રી કરવી
            if (cdnResponse.data && cdnResponse.data.Success === "1" && cdnResponse.data.files && cdnResponse.data.files.length > 0) {
                
                const uploadedFile = cdnResponse.data.files[0];
                const fileUrl = uploadedFile.file_url;

                const payload = {
                    user_id: currentUserId,
                    photo: fileUrl, // 🔴 CDN ની લિંક અહીં પાસ કરી
                    base64: "" // હવે Base64 ની જરૂર નથી
                };

                console.log("Updating profile photo payload:", payload);

                const response = await axios.post(`${BASE_URL}/api/change_profile_photo`, payload);

                if (response.data.success || response.data.Success === "1" || (response.data.data && response.data.data.Success === "1")) {
                    alert(txt.photoUpdated);
                    
                    // Update the photo in state and localStorage
                    setPhotoUrl(fileUrl);
                    localStorage.setItem('userPhoto', fileUrl);
                    localStorage.setItem('photo_path', fileUrl);
                    
                    // Update context if available
                    if (setUserPhoto) {
                        setUserPhoto(fileUrl);
                    }
                } else {
                    alert(txt.photoError);
                }
            } else {
                alert("Failed to upload image to CDN server.");
            }
        } catch (error) {
            console.error("Error uploading photo:", error);
            alert(txt.photoError);
        } finally {
            setIsUploadingPhoto(false);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    };

    // --- Logout Logic ---
    const handleLogout = () => {
        if (window.confirm(txt.logoutConfirm)) {
            localStorage.clear();
            navigate('/login');
        }
    };

    const menuOptions = [
        {
            title: txt.liveVoting,
            path: '/dis_live_voting_user',
            icon: (
                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    <path d="M2 20L22 20"></path>
                    <path d="M4 16h4"></path>
                    <path d="M16 16h4"></path>
                    <path d="M8 12h2"></path>
                    <path d="M14 12h2"></path>
                    <path d="M10 8h4"></path>
                    <path d="M12 4v4"></path>
                </svg>
            ),
            color: 'text-emerald-500',
            bg: 'bg-emerald-50'
        },
        {
            title: txt.changeResp,
            path: '/chnage_responcibility',
            icon: (
                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
            ),
            color: 'text-violet-500',
            bg: 'bg-violet-50'
        },
        {
            title: txt.privacyPolicy,
            path: '/privacy_policy',
            icon: (
                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                    <line x1="12" y1="8" x2="12" y2="14"></line>
                    <line x1="12" y1="17" x2="12.01" y2="17"></line>
                </svg>
            ),
            color: 'text-slate-500',
            bg: 'bg-slate-50'
        },
        {
            title: txt.contactUs,
            path: '/contact_us', 
            icon: (
                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
            ),
            color: 'text-blue-500',
            bg: 'bg-blue-50'
        },
        {
            title: txt.logout,
            action: handleLogout,
            icon: (
                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                    <polyline points="16 17 21 12 16 7"></polyline>
                    <line x1="21" y1="12" x2="9" y2="12"></line>
                </svg>
            ),
            color: 'text-red-500',
            bg: 'bg-red-50'
        }
    ];

    return (
        <div className="app-container p-4 profile-page-wrapper">
            
            <Header title={txt.title} />

            <div className="container-fluid mt-4">
                <div className="row g-4">
                    
                    {/* --- LEFT SIDE: PROFILE CARD --- */}
                    <div className="col-12 col-lg-4">
                        <div className="profile-identity-card">
                            <div className="profile-header-bg"></div>
                            
                            <div className="profile-avatar-container">
                                <div 
                                    className="profile-avatar-wrapper"
                                    onClick={() => fileInputRef.current?.click()}
                                    style={{ cursor: 'pointer', position: 'relative' }}
                                >
                                    <img 
                                        src={profilePhoto} 
                                        alt={name} 
                                        className="profile-avatar-img"
                                        style={{ opacity: isUploadingPhoto ? 0.5 : 1 }}
                                    />
                                    
                                    {/* Camera Icon Overlay - Always visible */}
                                    <div className="camera-icon-overlay">
                                        <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                            <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
                                            <circle cx="12" cy="13" r="4"></circle>
                                        </svg>
                                    </div>
                                    
                                    {/* Edit Overlay - On Hover */}
                                    {!isUploadingPhoto && (
                                        <div className="avatar-edit-overlay">
                                            <svg width="24" height="24" fill="none" stroke="white" strokeWidth="2" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                                                <circle cx="12" cy="13" r="4" />
                                            </svg>
                                            <span className="edit-text">{txt.updatePhoto}</span>
                                        </div>
                                    )}
                                    
                                    {/* Loading State Overlay */}
                                    {isUploadingPhoto && (
                                        <div className="uploading-overlay">
                                            <div className="spinner-small"></div>
                                            <span className="uploading-text">{txt.uploading}</span>
                                        </div>
                                    )}
                                    
                                    {/* Hidden File Input */}
                                    <input 
                                        type="file" 
                                        ref={fileInputRef} 
                                        onChange={handlePhotoChange} 
                                        accept="image/*" 
                                        style={{ display: 'none' }} 
                                    />
                                </div>
                                <div className="status-indicator"></div>
                            </div>
                            
                            <div className="profile-details-body">
                                <h2 className="profile-name">{name}</h2>
                                <span className="profile-role-badge">{displayRole}</span>
                                
                                <div className="profile-contact-info mt-4">
                                    <div className="contact-item">
                                        <div className="contact-icon">
                                            <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                                        </div>
                                        <div className="contact-text">
                                            <span className="contact-label">Mobile Number</span>
                                            <span className="contact-value">{mobile}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* --- RIGHT SIDE: MENU OPTIONS GRID --- */}
                    <div className="col-12 col-lg-8">
                        <div className="profile-menu-container">
                            <h4 className="menu-section-title">Settings & Activity</h4>
                            
                            <div className="menu-grid">
                                {menuOptions.map((option, index) => (
                                    <div 
                                        key={index} 
                                        className="menu-option-card"
                                        onClick={() => option.action ? option.action() : navigate(option.path)}
                                    >
                                        <div className={`menu-icon-wrapper ${option.bg} ${option.color}`}>
                                            {option.icon}
                                        </div>
                                        <div className="menu-text-wrapper">
                                            <h5 className="menu-option-title">{option.title}</h5>
                                        </div>
                                        <div className="menu-chevron">
                                            <svg width="20" height="20" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                                                <polyline points="9 18 15 12 9 6"></polyline>
                                            </svg>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <style jsx>{`
                .profile-page-wrapper {
                    background: #E5E7EB;
                    min-height: 100vh;
                }

                /* --- LEFT SIDE PROFILE CARD STYLES --- */
                .profile-identity-card {
                    background: #ffffff;
                    border-radius: 20px;
                    overflow: hidden;
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
                    border: 1px solid #f1f5f9;
                    position: relative;
                }

                .profile-header-bg {
                    height: 120px;
                    background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
                }

                .profile-avatar-container {
                    position: relative;
                    width: 120px;
                    height: 120px;
                    margin: -60px auto 0;
                    display: flex;
                    justify-content: center;
                }

                .profile-avatar-wrapper {
                    position: relative;
                    cursor: pointer;
                    border-radius: 50%;
                }

                .profile-avatar-img {
                    width: 120px;
                    height: 120px;
                    border-radius: 50%;
                    border: 4px solid #ffffff;
                    object-fit: cover;
                    background: #ffffff;
                    box-shadow: 0 4px 10px rgba(0,0,0,0.1);
                    transition: opacity 0.3s ease;
                }

                /* Camera Icon Overlay - Always visible */
                .camera-icon-overlay {
                    position: absolute;
                    bottom: 8px;
                    right: 8px;
                    background: #2563eb;
                    border-radius: 50%;
                    width: 32px;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    border: 2px solid white;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
                    z-index: 2;
                }

             

                .profile-avatar-wrapper:hover .avatar-edit-overlay {
                    opacity: 1;
                }

                
                .edit-text {
                    color: white;
                    font-size: 10px;
                    font-weight: 600;
                    text-align: center;
                }

                /* Uploading Overlay */
                .uploading-overlay {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0, 0, 0, 0.7);
                    border-radius: 50%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    z-index: 4;
                }

                .spinner-small {
                    width: 24px;
                    height: 24px;
                    border: 3px solid rgba(255, 255, 255, 0.3);
                    border-top: 3px solid #ffffff;
                    border-radius: 50%;
                    animation: spin 0.8s linear infinite;
                }

                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }

                .uploading-text {
                    color: white;
                    font-size: 10px;
                    font-weight: 600;
                }

                .status-indicator {
                    position: absolute;
                    bottom: 8px;
                    right: 8px;
                    width: 20px;
                    height: 20px;
                    background: #22c55e;
                    border: 3px solid #ffffff;
                    border-radius: 50%;
                }

                .profile-details-body {
                    padding: 20px 24px 30px;
                    text-align: center;
                }

                .profile-name {
                    margin: 0 0 8px 0;
                    font-size: 1.5rem;
                    font-weight: 800;
                    color: #0f172a;
                }

                .profile-role-badge {
                    display: inline-block;
                    background: #eff6ff;
                    color: #2563eb;
                    padding: 4px 16px;
                    border-radius: 50px;
                    font-size: 0.85rem;
                    font-weight: 700;
                    letter-spacing: 0.5px;
                    text-transform: uppercase;
                }

                .profile-contact-info {
                    margin-top: 24px;
                    padding-top: 20px;
                    border-top: 1px dashed #e2e8f0;
                    text-align: left;
                }

                .contact-item {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    padding: 12px;
                    background: #f8fafc;
                    border-radius: 12px;
                    border: 1px solid #f1f5f9;
                }

                .contact-icon {
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                    background: #ffffff;
                    color: #64748b;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.02);
                }

                .contact-text {
                    display: flex;
                    flex-direction: column;
                }

                .contact-label {
                    font-size: 0.75rem;
                    color: #64748b;
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }

                .contact-value {
                    font-size: 1rem;
                    font-weight: 700;
                    color: #0f172a;
                }

                /* --- RIGHT SIDE MENU STYLES --- */
                .profile-menu-container {
                    background: #ffffff;
                    border-radius: 20px;
                    padding: 24px;
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
                    border: 1px solid #f1f5f9;
                    height: 100%;
                }

                .menu-section-title {
                    margin: 0 0 20px 0;
                    font-size: 1.1rem;
                    font-weight: 700;
                    color: #334155;
                    border-left: 4px solid #2563eb;
                    padding-left: 12px;
                }

                .menu-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 16px;
                }

                .menu-option-card {
                    display: flex;
                    align-items: center;
                    padding: 16px;
                    background: #ffffff;
                    border: 1px solid #e2e8f0;
                    border-radius: 16px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                }

                .menu-option-card:hover {
                    border-color: #cbd5e1;
                    background: #f8fafc;
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(0,0,0,0.03);
                }

                .menu-icon-wrapper {
                    width: 48px;
                    height: 48px;
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 16px;
                }

                .menu-text-wrapper {
                    flex-grow: 1;
                }

                .menu-option-title {
                    margin: 0;
                    font-size: 0.95rem;
                    font-weight: 700;
                    color: #1e293b;
                }

                .menu-chevron {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: transform 0.2s ease;
                }

                .menu-option-card:hover .menu-chevron {
                    transform: translateX(4px);
                }

                /* Additional Color */
                .bg-cyan-50 { background-color: #ecfeff; }
                .text-cyan-500 { color: #06b6d4; }

                /* Utility Colors */
                .bg-blue-50 { background-color: #eff6ff; }
                .text-blue-500 { color: #3b82f6; }
                
                .bg-emerald-50 { background-color: #ecfdf5; }
                .text-emerald-500 { color: #10b981; }

                .bg-amber-50 { background-color: #fffbeb; }
                .text-amber-500 { color: #f59e0b; }

                .bg-violet-50 { background-color: #f5f3ff; }
                .text-violet-500 { color: #8b5cf6; }

                .bg-slate-50 { background-color: #f8fafc; }
                .text-slate-500 { color: #64748b; }

                .bg-red-50 { background-color: #fef2f2; }
                .text-red-500 { color: #ef4444; }

                /* --- RESPONSIVE ADJUSTMENTS --- */
                @media (max-width: 992px) {
                    .menu-grid {
                        grid-template-columns: 1fr;
                    }
                }

                @media (max-width: 768px) {
                    .profile-page-wrapper {
                        padding: 10px !important;
                    }
                    .profile-identity-card {
                        margin-bottom: 8px;
                    }
                    .menu-grid {
                        grid-template-columns: 1fr;
                        gap: 12px;
                    }
                    .menu-option-card {
                        padding: 12px 16px;
                    }
                    .menu-icon-wrapper {
                        width: 40px;
                        height: 40px;
                        margin-right: 12px;
                    }
                    .menu-icon-wrapper svg {
                        width: 20px;
                        height: 20px;
                    }
                    .profile-avatar-img {
                        width: 100px;
                        height: 100px;
                    }
                    .profile-avatar-container {
                        width: 100px;
                        height: 100px;
                        margin: -50px auto 0;
                    }
                    .edit-text {
                        font-size: 8px;
                    }
                    .camera-icon-overlay {
                        width: 28px;
                        height: 28px;
                        bottom: 6px;
                        right: 6px;
                    }
                    .camera-icon-overlay svg {
                        width: 16px;
                        height: 16px;
                    }
                }
            `}</style>
        </div>
    );
};

export default ProfilePage;